var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calling - Bold 24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calling_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M19.227 7.31903C18.5922 7.20178 18.0093 7.60683 17.8885 8.2264C17.7676 8.84598 18.174 9.4509 18.7914 9.57215C20.6504 9.93457 22.0859 11.3736 22.4497 13.239V13.2403C22.5533 13.7773 23.026 14.1677 23.5704 14.1677C23.6434 14.1677 23.7165 14.161 23.7908 14.1477C24.4083 14.0238 24.8146 13.4202 24.6938 12.7993C24.1507 10.0132 22.0062 7.86132 19.227 7.31903Z",
    fill: "#21E786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    d: "M19.1444 2.67659C18.8469 2.63395 18.5482 2.72189 18.3105 2.91109C18.0662 3.10296 17.9135 3.38011 17.8803 3.69056C17.8099 4.31813 18.2627 4.88574 18.8894 4.95636C23.2117 5.43869 26.5712 8.80571 27.0572 13.1414C27.1222 13.7223 27.6096 14.1607 28.1912 14.1607C28.235 14.1607 28.2775 14.158 28.3213 14.1527C28.6254 14.1194 28.8963 13.9688 29.0875 13.729C29.2774 13.4892 29.3637 13.1907 29.3291 12.8856C28.7236 7.47596 24.5369 3.27751 19.1444 2.67659Z",
    fill: "#21E786"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7103 17.2965C20.0291 22.6138 21.2357 16.4623 24.6222 19.8464C27.887 23.1103 29.7635 23.7643 25.627 27.8996C25.1088 28.316 21.8168 33.3257 10.2474 21.7596C-1.32334 10.192 3.68342 6.89659 4.09993 6.3786C8.24646 2.23179 8.88912 4.11918 12.154 7.38311C15.5405 10.7687 9.39151 11.9792 14.7103 17.2965Z",
    fill: "#21E786"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone-2.31feba81ad83cb9e12eb952cfe0b0cfc.svg";
export { ForwardRef as ReactComponent };